import { jwtDecode } from "jwt-decode";
import { getAuthToken, redirectToLogin } from "./utils/auth";
import { staticApis } from "./api";

// Optional hardcoded tokens for local debugging (keep commented in normal use):
// const getToken = "eyJ...";

const getToken = getAuthToken();

let employeeId = "";
let roleName = "";
let userNameEmpId = {};

try {
  if (!getToken) {
    throw new Error("No auth token cookie found");
  }

  const decodedToken = jwtDecode(getToken);
  employeeId = decodedToken.employeeNo;
  userNameEmpId = {
    name: decodedToken.name,
    empId: decodedToken.employeeNo,
    email: decodedToken.email,
  };
  const listOfPortalName = decodedToken.portalAccess || [];

  if (decodedToken?.isAdmin) {
    roleName = "Admin";
  } else if (
    !decodedToken?.isAdmin &&
    !listOfPortalName.some((role) => role.portalName === "MEETING ROOM")
  ) {
    redirectToLogin();
  } else {
    roleName = listOfPortalName.find(
      (role) => role.portalName === "MEETING ROOM"
    ).roleName;
  }
} catch (error) {
  console.warn("[auth] Unable to establish local session:", error?.message || error);
  redirectToLogin();
}

/**
 * Load Meeting Room role from DB (userAccess). DB wins over JWT portal role.
 */
const refreshRoleFromDatabase = async () => {
  if (!employeeId) return GetRole();
  try {
    const res = await staticApis.getMeetingRoomRole(employeeId);
    const dbRole = res?.data?.roleName;
    if (dbRole) {
      roleName = dbRole;
    }
  } catch (error) {
    console.warn("[auth] Failed to load meeting room role from DB:", error);
  }
  return GetRole();
};

const GetRole = () => {
  if (roleName === "Admin") {
    return "admin";
  }
  if (roleName === "View") {
    return "";
  }
  return roleName ? String(roleName).toLowerCase() : "";
};

export { GetRole, employeeId, userNameEmpId, getToken, refreshRoleFromDatabase };
